import { GtmEvents } from '@/gtm/gtm-events';
import { PAYMENT_METHODS } from '@/constants/payment';

const deliveryTypes = {
  store: 'Магазин',
  pvz: 'ПВЗ',
  postamat: 'Постамат',
  courier: 'Курьер',
};

const paymentMethods = {
  [PAYMENT_METHODS.online]: 'Онлайн',
  [PAYMENT_METHODS.fps]: 'СБП',
  [PAYMENT_METHODS.cashOnly]: 'ПриПолучении',
  [PAYMENT_METHODS.cashOrCard]: 'ПриПолучении',
};

const discountTypes = {
  promocode: 'Промокод',
  bonus: 'Бонус',
  promotion: 'Акция',
  ware_discount: 'Акция',
};

export class CartGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВКорзине';

  viewCartPage({ cartId, products }) {
    const eventLabel = {
      cart_id: cartId,
      products: products.map(({ quantity, models: [model] }) => ({
        id: model?.code,
        price: model?.price?.discountPrice,
        quantity,
      })),
    };

    const checkoutProducts = products.map(({ quantity, skuId, models: [model] }) => ({
      dimension11: skuId,
      price: model?.price?.discountPrice,
      quantity,
    }));

    return this.gtmEvent({
      eventAction: 'Корзина_ПросмотрСтраницы',
      eventLabel: JSON.stringify(eventLabel),
      params: {
        ecommerce: {
          checkout: {
            products: checkoutProducts,
          }
        }
      },
    });
  }

  notChooseDeliveryType({ value } = {}) {
    return this.gtmEvent({
      eventAction: 'Корзина_НеВыбранСпособДоставки',
      eventLabel: value,
    });
  }

  submitOrder() {
    return this.gtmEvent({
      eventAction: 'Корзина_КнопкаОформитьЗаказ',
    });
  }

  shippingByPickup() {
    return this.gtmEvent({
      eventAction: 'Корзина_СпособДоставки_Самовывоз',
    });
  }

  shippingByPickupStore() {
    return this.gtmEvent({
      eventAction: 'Корзина_СпособДоставки_Самовывоз_КнопкаВыбратьЭтотПункт',
    });
  }

  shippingByCourier() {
    return this.gtmEvent({
      eventAction: 'Корзина_СпособДоставки_КурьерскаяСлужба',
    });
  }

  paymentMethodPreselected({ method }) {
    return this.gtmEvent({
      eventAction: 'КРЗ_СпособОплаты_Предвыбран',
      eventLabel: method?.title,
    });
  }

  changePaymentMethod() {
    return this.gtmEvent({
      eventAction: 'КРЗ_СпособОплаты_Изменить',
    });
  }

  paymentMethodChanged({ selectedMethod, availableMethods = [] }) {
    const eventLabel = JSON.stringify({
      'НовыйСпособОплаты': availableMethods.find(({ value }) => value === selectedMethod)?.title,
      'ДоступныеСпособы': availableMethods.map(({ title }) => title),
    });

    return this.gtmEvent({
      eventAction: 'КРЗ_СпособОплаты_Изменен',
      eventLabel,
    });
  }

  successSubmitOrder({ cartId, orders, subtotal, discounts = [] }) {
    let eventLabel = '';
    try {
      let appliedDiscounts = discounts.reduce((res, { type }) => {
        discountTypes[type] && res.add(discountTypes[type]);
        return res;
      }, new Set());

      appliedDiscounts = [...appliedDiscounts].join('|');

      eventLabel = JSON.stringify({
        'НомерКорзины': cartId,
        'Количество заказов': orders.length,
        'СтоимостьКорзины': subtotal,
        'ТипКорзины': orders.length === 1 ? 'Монокорзина' : 'Мультикорзина',
        'Заказы': orders.map(order => ({
          'НомерЗаказа': order.orderNumber,
          'СуммаЗаказа': order.subtotal,
          'СпособДоставки': order.shippingGroupType === 'delivery'
            ? deliveryTypes.courier
            : deliveryTypes[order.storeType],
          'СпособОплаты': paymentMethods[order.paymentMethod],
          'НужнаПредоплата': order.needPrepay ? 'Да' : 'Нет',
          'СкидочныеМеханики': appliedDiscounts,
        })),
      });
    } catch (e) {
      console.error(e);
    }

    return this.gtmEvent({
      eventAction: 'КРЗ_ОформленЗаказ_Успешно',
      eventLabel,
    });
  }
}

export const cartGtmEvents = new CartGtmEvents();
